<itl-text
  [(ngModel)]="text"
  [title]="node.title + ' / ' + (node.options && node.options.unit ? node.options.unit : '')"
  [required]="node.mandatory"
  [description]="node.description"
  type="text"
  [icon]="node.globalType ? (node.globalType | globalTypeIcon) : null"
>
</itl-text>
